'use client';
import React from 'react';
import classes from '../styles.module.scss';
import { Control, useController, useFormContext } from 'react-hook-form';
import { NumericFormat } from 'react-number-format';
import Typography from '@/components/shared/typography/typography.component';
import { useTranslation } from '@/hook';

const TextFieldFormControlled = ({
  name,
  control,
  leadingText,
  numeric,
  placeholder,
}: {
  name: string;
  control: Control;
  leadingText?: string;
  numeric?: boolean;
  placeholder?: string;
}) => {
  const { field } = useController({ name, control });
  const {
    formState: { errors },
  } = useFormContext();
  const { t } = useTranslation();
  return (
    <div className={classes.input_container}>
      <Typography variant={'body2Medium'} className={classes.input_label}>
        {leadingText}
      </Typography>
      {numeric ? (
        <NumericFormat
          allowLeadingZeros={false}
          allowNegative={false}
          {...field}
          className={classes.input}
          style={{
            borderColor: errors[name] ? '#FDA29B' : '#d0d5dd',
          }}
          valueIsNumericString={true}
          thousandSeparator={true}
        />
      ) : (
        <input
          {...field}
          className={classes.input}
          ref={(e) => {
            field.ref(e);
          }}
          placeholder={placeholder}
          style={{
            borderColor: errors[name] ? '#FDA29B' : '#d0d5dd',
            paddingInline: leadingText ? '46px' : '12px',
          }}
        />
      )}

      {errors[name]?.message && (
        <span className={classes.input_error}>{t(errors[name]?.message as string) || ''}</span>
      )}
    </div>
  );
};
export default TextFieldFormControlled;
